import SliderRrss from './SliderRrss'

export default SliderRrss
